import { Box, Button, Typography } from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import { Grid, GridColumn, GridToolbar } from '@progress/kendo-react-grid';
import i18next from 'i18next';
import React, { Fragment, useMemo } from 'react';
import { InlineEditingActionsCell } from '../../../../../../Hooks/useKendoGrid';
import useStylesGrid from '../../../../../../styles/grid.styles';
import { InputCell } from '../../../../../../ui';
import LoadingIndicator from '../../../../../../ui/old/Feedback/LoadingIndicator';
import { useDeelProjectsQuery } from '../../../../hooks/useDGManagement';
import useDGManagement from './useDGManagement';

const DGManagementGrid = () => {
    const { data } = useDeelProjectsQuery();
    const classesGrid = useStylesGrid();
    const {
        idField,
        editField,
        gridState,
        gridResult,
        handleDataStateChange,
        handleItemChange,
        validate,
        inlineEditing: { addNew, add, discard, enterEdit, update, cancel, remove },
        mutations: {
            createDGManagementMutation: { isLoading },
        },
    } = useDGManagement(data);
    const DescriptionCell = useMemo(() => (props: any) => <InputCell {...props} maxChars={50} />, []);
    const CustomInputCell = useMemo(
        () => (props: any) => <InputCell {...props} maxChars={50} pattern="^(?!\s*$).+" />,
        [],
    );

    return (
        <Fragment>
            {data ? (
                <Fragment>
                    <Grid
                        className={`${classesGrid.grid}`}
                        style={{
                            marginTop: '1%',
                            marginBottom: '2%',
                        }}
                        {...gridState}
                        {...gridResult}
                        sortable={true}
                        onDataStateChange={handleDataStateChange}
                        dataItemKey={idField}
                        editField={editField}
                        onItemChange={handleItemChange}
                    >
                        <GridToolbar>
                            <Box style={{ minHeight: '30px' }} display="flex" justifyContent="space-between">
                                <Typography variant="h6" style={{ color: 'rgba(0, 0, 0, 0.87)' }}>
                                    Deelproject management
                                </Typography>
                                <Button
                                    onClick={addNew}
                                    variant="contained"
                                    style={{ minWidth: 32, height: 32, padding: 0, borderRadius: '50%' }}
                                >
                                    <AddIcon style={{ fontSize: 16 }} />
                                </Button>
                            </Box>
                        </GridToolbar>
                        <GridColumn
                            field="name"
                            title={'Deelproject'}
                            headerClassName={`${classesGrid.gridColumnHeader}`}
                            cell={CustomInputCell}
                            className={classesGrid.gridColumn}
                        />
                        <GridColumn
                            field="description"
                            title={'Description'}
                            headerClassName={`${classesGrid.gridColumnHeader}`}
                            cell={DescriptionCell}
                            className={classesGrid.gridColumn}
                        />
                        <GridColumn
                            title=" "
                            width={'90px'}
                            headerClassName={`${classesGrid.gridColumnHeader} ${classesGrid.defaultCursor}`}
                            className={classesGrid.gridColumn}
                            cell={(props) => (
                                <InlineEditingActionsCell
                                    {...props}
                                    edit={enterEdit}
                                    remove={remove}
                                    add={add}
                                    discard={discard}
                                    update={update}
                                    cancel={cancel}
                                    idField={idField}
                                    editField={editField}
                                    validate={validate}
                                    isLoading={isLoading}
                                    confirmationMessage={i18next.t('licenses.deleteDG')}
                                    withoutHeaderStyle
                                />
                            )}
                        />
                    </Grid>
                </Fragment>
            ) : (
                <LoadingIndicator />
            )}
        </Fragment>
    );
};

export default DGManagementGrid;
